<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Rekomendasi Penilaian Pelaksanaan</h2>
    <Widget customHeader>
      <div class="d-flex justify-content-end mb-3">
        <div class="d-flex align-items-start">
          <div class="d-flex flex-column">
            <div v-for="(filter, index) in filters" :key="index" class="d-flex align-items-center mb-2">
              <label class="mr-2 mb-0 text-nowrap">Filter {{ index + 1 }}</label>

              <select v-model="filter.field" class="form-control mr-2" @change="resetFilter(filter)">
                <option
                  v-for="option in filterFields"
                  :key="option.value"
                  :value="option.value"
                  :disabled="isFieldSelected(option.value, filter.field)"
                >
                  {{ option.label }}
                </option>
              </select>

              <div v-if="isRangeSearch(filter.field)" class="d-flex align-items-center">
                <label class="mb-0 mr-1">Mulai</label>
                <input
                  v-model="filter.from"
                  :type="filter.field === 'total_skor' ? 'number' : 'date'"
                  class="form-control mr-2"
                />
                <label class="mb-0 mr-1">Sampai</label>
                <input
                  v-model="filter.to"
                  :type="filter.field === 'total_skor' ? 'number' : 'date'"
                  class="form-control mr-2"
                />
              </div>

              <input v-else v-model="filter.value" type="text" class="form-control mr-2" />

              <button v-if="index > 0" type="button" class="btn btn-outline-danger" @click="removeFilter(index)">
                Hapus
              </button>
            </div>

            <button
              v-if="filters.length < 3"
              type="button"
              class="btn btn-outline-primary align-self-start"
              @click="addFilter"
            >
              Tambah Filter
            </button>
          </div>

          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label class="mb-0 text-nowrap">Sort By: </label>
            </div>

            <select v-model="sort.field" class="form-control">
              <option value="tanggal_submit_laporan">Tgl. Pelaporan</option>
              <option value="tahun_laporan">Tahun Laporan</option>
              <option value="nama_pemegang">Nama Pemegang</option>
              <option value="total_skor">Skor</option>
              <option value="tanggal_penilaian">Tgl. Penilaian</option>
            </select>

            <select v-model="sort.direction" class="form-control ml-2">
              <option value="DESC">DESC</option>
              <option value="ASC">ASC</option>
            </select>
          </div>
        </div>
      </div>

      <table id="tabel_rekomendasi_penilaian_pelaksanaan" class="table" style="width: 100%">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Pemegang</th>
            <th>Nomor KKPRL</th>
            <th>Tahun Laporan</th>
            <th>Tgl. Pelaporan</th>
            <th>Status Penyampaian</th>
            <th>Lokasi</th>
            <th>Nilai</th>
            <th>Skor</th>
            <th>Penilai</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td colspan="11" class="text-center">Memuat data...</td>
          </tr>
          <tr v-else-if="!dataLaporan.length">
            <td colspan="11" class="text-center">Tidak ada data</td>
          </tr>
          <template v-else>
            <tr v-for="(data, index) in dataLaporan" :key="data.id">
              <td>{{ pagination.firstInPage + index }}</td>
              <td>{{ data.nama_pemegang || '-' }}</td>
              <td>{{ data.nomor_kkprl || '-' }}</td>
              <td>{{ data.tahun_laporan || '-' }}</td>
              <td>{{ formatDate(data.tanggal_submit_laporan, 'DD MMMM YYYY') || '-' }}</td>
              <td>{{ data.status_penyampaian }}</td>
              <td>{{ data.provinsi }}</td>
              <td>{{ data.nilai || '-' }}</td>
              <td>{{ data.total_skor || '-' }}</td>
              <td>{{ data.nama_penilai || '-' }}</td>
              <td>
                <div class="d-flex flex-column">
                  <div>
                    <b-button size="sm" variant="info" class="mb-1" @click="tinjauLaporan(data.id)">
                      Tinjau Penilaian Laporan
                    </b-button>
                  </div>
                  <div v-if="!data.id_rencana_aksi">
                    <b-button size="sm" variant="success" @click="buatRencanaAksi(data)"> Buat Rencana Aksi </b-button>
                  </div>
                  <div v-else>
                    <b-button size="sm" variant="info" @click="lihatRencanaAksi(data)"> Lihat Rencana Aksi </b-button>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai
            {{
              pagination.currentPage !== pagination.lastPage
                ? pagination.limit * pagination.currentPage
                : pagination.total
            }}
            dari {{ pagination.total }} data
          </template>
        </div>

        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'first' })">Awal</a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'prev' })">Sebelumnya</a>
            </li>

            <li v-for="(i, index) in pagination.pageNumber" :key="index" class="page-item">
              <a
                :class="['page-link', { active: i === `${pagination.currentPage}` }]"
                href="#"
                @click.prevent="changePage({ page: i })"
              >
                {{ i }}
              </a>
            </li>

            <li :class="['page-item', { disabled: pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'next' })">Selanjutnya</a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'last' })">Akhir</a>
            </li>
          </ul>
        </nav>
      </div>
    </Widget>
  </div>
</template>

<script>
import api from '@/services/api'
import Widget from '@/components/Widget/Widget'
import { formatDate, hasRole } from '@/helper/helpernew'
import Swal from 'sweetalert2'

export default {
  name: 'RekomendasiPenilaianPelaksanaan',
  components: { Widget },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {},
      dataLaporan: [],
      isLoading: false,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: 1,
        pageNumber: [],
        limit: 10,
        total: 0,
        firstInPage: 0,
      },
      filterFields: [
        { value: 'nama_pemegang', label: 'Nama Pemegang' },
        { value: 'nomor_kkprl', label: 'Nomor KKPRL' },
        { value: 'tahun_laporan', label: 'Tahun Laporan' },
        { value: 'tanggal_submit_laporan', label: 'Tgl. Pelaporan' },
        { value: 'provinsi', label: 'Lokasi' },
        { value: 'nilai', label: 'Nilai' },
        { value: 'total_skor', label: 'Skor' },
        { value: 'nama_penilai', label: 'Penilai' },
      ],
      filters: [{ field: 'nama_pemegang', value: '', from: '', to: '' }],
      sort: {
        field: 'tanggal_submit_laporan',
        direction: 'DESC',
      },
      debounceTerm: null,
    }
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy() {
    clearTimeout(this.debounceTerm)
  },
  methods: {
    formatDate,

    isRangeSearch(field) {
      return ['tanggal_submit_laporan', 'total_skor'].includes(field)
    },

    isFieldSelected(field, currentField) {
      return field !== currentField && this.filters.some((filter) => filter.field === field)
    },

    resetFilter(filter) {
      filter.value = ''
      filter.from = ''
      filter.to = ''
    },

    addFilter() {
      const field = this.filterFields.find((option) => !this.filters.some((filter) => filter.field === option.value))

      if (field && this.filters.length < 3) {
        this.filters.push({ field: field.value, value: '', from: '', to: '' })
      }
    },

    removeFilter(index) {
      this.filters.splice(index, 1)
    },

    getSearchFilter() {
      return this.filters
        .reduce((conditions, filter) => {
          if (this.isRangeSearch(filter.field)) {
            conditions.push(
              ...[
                filter.from !== '' && `${filter.field},>=,${filter.from}`,
                filter.to !== '' && `${filter.field},<=,${filter.to}`,
              ].filter(Boolean),
            )
            return conditions
          }

          if (filter.value !== '' && filter.value !== null) {
            const operator = filter.field === 'provinsi' ? 'contains' : 'like'
            conditions.push(`${filter.field},${operator},${filter.value}`)
          }

          return conditions
        }, [])
        .join(';')
    },

    buildFilter() {
      const curYear = new Date().getFullYear()
      const filters = ['rekomendasi_penilaian_kkprl,=,Ya', `tahun_laporan,=,${curYear}`]

      if (hasRole(this.user, 'Verifikator') && !hasRole(this.user, 'Superuser')) {
        filters.push(`nama_upt,=,${this.user.nama_upt}`)
      }

      const searchFilter = this.getSearchFilter()

      if (searchFilter) {
        filters.push(searchFilter)
      }

      return filters.join(';')
    },

    mapLaporan(item) {
      const provinsi = Array.isArray(item.provinsi) ? item.provinsi[0] || '-' : item.provinsi || '-'

      let statusPenyampaian = '-'

      if (item.tanggal_penerbitan && item.tanggal_submit_laporan) {
        const batas = new Date(item.tanggal_penerbitan)
        batas.setFullYear(Number(item.tahun_laporan))
        batas.setHours(0, 0, 0, 0)

        const lapor = new Date(item.tanggal_submit_laporan)
        lapor.setHours(0, 0, 0, 0)

        statusPenyampaian = lapor >= batas ? 'Telat' : 'Tidak Telat'
      }

      return {
        ...item,
        provinsi,
        status_penyampaian: statusPenyampaian,
      }
    },

    destroyDatatable() {
      const table = window.$ && window.$.fn.DataTable
      if (table && window.$.fn.DataTable.isDataTable('#tabel_rekomendasi_penilaian_pelaksanaan')) {
        window.$('#tabel_rekomendasi_penilaian_pelaksanaan').DataTable().destroy()
      }
    },

    initDatatable() {
      window.$('#tabel_rekomendasi_penilaian_pelaksanaan').DataTable({
        paging: false,
        searching: false,
        info: false,
        ordering: false,
        destroy: true,
        retrieve: true,
        fixedColumns: { left: 2, right: 1 },
        scrollX: true,
        scrollCollapse: true,
        dom: 't',
      })
    },

    async loadData() {
      this.destroyDatatable()
      this.isLoading = true

      const url =
        `api/laporan_tahunan?page=${this.pagination.currentPage}` +
        `&filter=${this.buildFilter()}` +
        `&sort=${this.sort.field},${this.sort.direction};createdAt,DESC`

      try {
        const response = await api.get(url)
        const result = response.data

        const limit = result.limit || 10
        const total = result.total || 0

        this.pagination.limit = limit
        this.pagination.total = total
        this.pagination.firstInPage = total ? (this.pagination.currentPage - 1) * limit + 1 : 0
        this.pagination.lastPage = Math.max(1, Math.ceil(total / limit))

        this.setPagination()
        this.dataLaporan = (result.data || []).map(this.mapLaporan)
      } catch (error) {
        this.dataLaporan = []
        const message = error.response?.data?.message || 'Gagal memuat data rekomendasi penilaian pelaksanaan'
        Swal.fire('Gagal', message, 'error')
      } finally {
        this.isLoading = false
        this.$nextTick(() => this.initDatatable())
      }
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch(() => {})

      this.pagination.pageNumber = []

      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1', '2', '3', '4', '5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(
            '1',
            '...',
            `${this.pagination.lastPage - 4}`,
            `${this.pagination.lastPage - 3}`,
            `${this.pagination.lastPage - 2}`,
          )
        } else {
          this.pagination.pageNumber.push(
            '1',
            '...',
            `${this.pagination.currentPage - 1}`,
            `${this.pagination.currentPage}`,
            `${this.pagination.currentPage + 1}`,
          )
        }

        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`, `${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...', `${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next' && this.pagination.currentPage < this.pagination.lastPage) {
        this.pagination.currentPage++
      }
      if (config.option === 'prev' && this.pagination.currentPage > 1) {
        this.pagination.currentPage--
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        this.pagination.currentPage = parseInt(config.page)
      }

      await this.loadData()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    async tinjauLaporan(id) {
      try {
        const response = await api.get(`api/penilaian_laporan?filter=id_laporan,=,${id}`)
        const penilaian = response.data.data[0]

        let url = `/app/penilaian-laporan-tahunan/tinjau?id_laporan=${id}`
        if (penilaian) {
          url += `&id_penilaian=${penilaian.id}`
        }

        this.$router.push(url)
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal membuka penilaian laporan'
        Swal.fire('Gagal', message, 'error')
      }
    },

    buatRencanaAksi(data) {
      const scope = this.user.nama_upt === 'PUSAT' ? 'pusat' : 'upt'

      this.$router.push({
        path: `/app/rencana-aksi/${scope}/form`,
        query: { no_kkprl: data.nomor_kkprl },
      })
    },

    lihatRencanaAksi(data) {
      const scope = this.user.nama_upt === 'PUSAT' ? 'pusat' : 'upt'

      this.$router.push({
        path: `/app/rencana-aksi/${scope}/form/${data.id_rencana_aksi}`,
      })
    },
  },
  watch: {
    filters: {
      handler() {
        clearTimeout(this.debounceTerm)
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.loadData()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler() {
        this.pagination.currentPage = 1
        this.loadData()
      },
      deep: true,
    },
  },
}
</script>

<style>
#tabel_rekomendasi_penilaian_pelaksanaan th,
#tabel_rekomendasi_penilaian_pelaksanaan td {
  white-space: nowrap;
}

#tabel_rekomendasi_penilaian_pelaksanaan td:nth-child(2) {
  white-space: normal;
  min-width: 250px;
}
</style>
